import {
  Box,
  FormHelperText,
  Checkbox as MUICheckbox,
  CheckboxProps as MuiCheckboxProps,
} from '@mui/material';

type CheckboxBaseProps = Pick<
  MuiCheckboxProps,
  | 'size'
  | 'color'
  | 'required'
  | 'checked'
  | 'aria-label'
  | 'name'
  | 'onChange'
  | 'id'
  | 'indeterminate'
  | 'disabled'
>;

export interface CheckboxProps extends CheckboxBaseProps {
  helpText?: string;
}

export function Checkbox({ helpText, ...rest }: CheckboxProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <MUICheckbox {...rest} />
      {helpText && <FormHelperText>{helpText}</FormHelperText>}
    </Box>
  );
}

export default Checkbox;
